import React from "react";

const WhatsAppButton = () => {
  const handleWhatsApp = () => {
    const message = "Hi, I would like to know more about your water filter services.";
    const phoneNumber = "+919265199516";

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(url, "_blank");
  };

  return (
    <div className="WhatsApp-Btn">
      <button
        onClick={handleWhatsApp}
        className="WhatsAppButton d-flex justify-content-center align-items-center border-0 rounded-1 shadow-lg position-relative overflow-hidden"
      >
        <i className="bi bi-whatsapp fs-4"></i>
      </button>
    </div>
  );
};

export default WhatsAppButton;
